<template>
	<div class="providerRegister">
		<div class="banner">
			<img src="static/img/provider-bg.png">
		</div>
		<h3>修改资料</h3>
		<div class="content">
			<div class="input">
				<span>手机号</span>
				<span class="phone">{{ phone }}</span>
			</div>
			<div class="input">
				<span>密码</span>
				<input type="password" v-model="password" autocomplete='new-password' placeholder="请输入密码" />
			</div>
			<div class="card-box clearfix">
				<span class="bindCard">绑定银行卡</span>
				<div class="cardMsg">
					<template v-if="bankStatus == 0">
						<span class="pass">已绑定</span>
					</template>
					<template v-else-if="bankStatus == 2">
						<span class="shenhz">审核中</span>
					</template>
					<template v-else-if="bankStatus == 3">
						<span class="nopass">审核不通过</span>
					</template>
					<template v-else>
						<span>未绑定</span>
					</template>
					<a :href="'/reginalAgent/providerBankCard?token='+tjk_login_token+'&providerCode='+providerCode+'&phone='+phone"><img src="static/img/icon_right.png" width="14px" /></a>
				</div>
			</div>
			<p class="tips-content">{{ content }}</p>
			<button class="btn-blue" @click="changeFun">确认修改</button>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'providerHasLogin',
		data() {
			return {
				providerCode: this.$route.query.providerCode,
				tjk_login_token: this.$route.query.token,
				phone: this.$route.query.phone,
				password: '',
				bankStatus: null,
				content: ''
			}
		},
		mounted() {
			this.queryBankStatus()
		},
		methods: {
			//查询银行卡绑定状态
			queryBankStatus() {
				this.$http.post(API_ROOT.tjuser + '/provider/getProviderCashInfo', {'tjk_login_token': this.tjk_login_token}).then(response=> {
					var result = response.data
					if(result.success) {
						this.bankStatus = !result.data.cashInfo ? null : result.data.cashInfo.status
						this.content = !result.data.content ? null : result.data.content
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			},
			//修改信息
			changeFun() {
				if(this.password == '') {
					this.$message({
						message: '请输入密码',
						type: 'error',
						center: true,
						duration: 3000
					})
					return
				}
				var data = {
					tjk_login_token: this.tjk_login_token,
					password: this.password
				}
				this.$http.post(API_ROOT.tjuser + '/provider/updateProviderInfo', data).then(response=> {
					var result = response.data
					if(result.success) {
						this.$message({
							message: '修改成功',
							type: 'success',
							center: true,
							duration: 3000
						})
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// providerHasLogin.vue?3fd44448